/*
 * 文件EN: behaviorScore.js,
 * 文件CN: ,
 * 创建时间: Tuesday, 12th May 2020 3:40:34 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import * as Models from '@/api/T3/DHGL/behaviorScore'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    getList(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },

    // 获取雷达图
    getRadar(ctx, payload) {
      return Models.radar(payload).then(res => {
        return res && res.status === 200 ? res.data : null
        // return res && res.status === 200 && res.data
      })
    },
    // 获取雷达图详情
    getRadarDetails(ctx, payload) {
      return Models.details(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 行业对比
    getIndustryComparison(ctx, payload) {
      return Models.industryComparison(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 行业对比详情
    getIndustryDetail(ctx, payload) {
      return Models.industryDetail(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    },
    // 总分行业对比
    getTotalScoreComparison(ctx, payload) {
      return Models.totalScoreComparison(payload).then(res => {
        return res && res.status === 200 ? res.data : null
      })
    }
  }
}
